import { render, staticRenderFns } from "./EmailGravatar.vue?vue&type=template&id=14e52b56&scoped=true&"
import script from "./EmailGravatar.vue?vue&type=script&lang=ts&"
export * from "./EmailGravatar.vue?vue&type=script&lang=ts&"
import style0 from "./EmailGravatar.vue?vue&type=style&index=0&id=14e52b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e52b56",
  null
  
)

export default component.exports